module.exports = __webpack_public_path__ + "static/media/fine.050c0d0c.png";